import { render, staticRenderFns } from "./ProductLayoutEdit.vue?vue&type=template&id=dbe1170a&scoped=true&"
import script from "./ProductLayoutEdit.vue?vue&type=script&lang=js&"
export * from "./ProductLayoutEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductLayoutEdit.vue?vue&type=style&index=0&id=dbe1170a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe1170a",
  null
  
)

export default component.exports